import { render, staticRenderFns } from "./SeleccionarRegion.vue?vue&type=template&id=4b2a4a7e"
import script from "./SeleccionarRegion.vue?vue&type=script&lang=js"
export * from "./SeleccionarRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports